module.exports = __webpack_public_path__ + "static/media/DSC_0092.feb9a31c.jpg";